module.exports = __webpack_public_path__ + "img/3-2-2.7e720f1f.png";